"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const googleTagManager_1 = require("./providers/googleTagManager");
class AnalyticsApi {
    constructor() {
        this.provider = new googleTagManager_1.GoogleTagManagerProvider();
    }
    async addSnippet(data) {
        return await this.provider.addSnippet(data);
    }
    async run(data) {
        return await this.provider.run(data);
    }
    async trackEvent(data) {
        return await this.provider.trackEvent(data);
    }
}
exports.default = AnalyticsApi;
;
//# sourceMappingURL=index.js.map